import React from 'react'

import { STEP_CONST } from '@constants/demoSaleApplication/constant'
import { DemoSellAlert } from '@zet/common/components/demoSellAlert'
import { Button, H4, SH1, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { getLoginHash } from '@zet/utils/loginHash'

import KeyBoardWrapper from '@components/keyboardWrapper'

import { useNavigation } from '@hooks/useNavigation'

import { useDemoSaleApplicationState } from '../../../../store/demoSaleApplicationState'
import { TestBrandApplicationHeader } from '../../../components/testBrancApplicationHeader'

export const VKyc = () => {
  const { setCurrentState } = useDemoSaleApplicationState((state) => state)
  const { navigate } = useNavigation()
  const hash = getLoginHash()

  function handlePress() {
    setCurrentState(STEP_CONST.APPLICATION_TRACKING)
    navigate('LeadApplicationStatus', { hash })
  }
  return (
    <KeyBoardWrapper
      className="flex-1 bg-white "
      BottomSheet={
        <Button onPress={handlePress} className="my-4/2 mx-3">
          {i18n.t('demoSale.submit')}
        </Button>
      }
    >
      <Stack className="flex-1 bg-white">
        <TestBrandApplicationHeader header={i18n.t('demoSale.vkyc.header')} />
        <DemoSellAlert content={i18n.t('demoSale.vkyc.info')} />
        <Stack className="mt-3 px-4">
          <H4 className="font-[Graphie-Bold]">{i18n.t('demoSale.vkyc.h2')}</H4>
        </Stack>
        <Stack className="mt-3 items-center justify-center px-8">
          <SH1 className="text-center">{i18n.t('demoSale.vkyc.sh1')}</SH1>
        </Stack>
      </Stack>
    </KeyBoardWrapper>
  )
}
